var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('board-detail-link',{attrs:{"boardData":_vm.boardData,"detailLayout":_vm.detailLayout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }